import { render, staticRenderFns } from "./ShippingAllocation.vue?vue&type=template&id=ae898066&scoped=true&"
import script from "./ShippingAllocation.vue?vue&type=script&lang=js&"
export * from "./ShippingAllocation.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAllocation.vue?vue&type=style&index=0&id=ae898066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae898066",
  null
  
)

component.options.__file = "ShippingAllocation.vue"
export default component.exports